<div class="edu-page" [class.pseucode-navbar]="this.currentRoute?.name == 'Pseudocode'" [class.navbar-collapsed-page]="
    this.navbarCollapsed && this.currentRoute?.name != 'Pseudocode'
  ">
  <div class="navbar top-pad" [class.dark-mode]="this.isDark" [class.navbar-collapsed]="
      this.currentRoute?.name == 'Pseudocode' || this.navbarCollapsed
    " [class.hide]="!this.sideNavOpen">
    <!-- Logo container with collapse button -->
    <div class="logo-container">
      <edu-logo class="logo" [collapsed]="
          this.currentRoute?.name == 'Pseudocode' || this.navbarCollapsed
        "></edu-logo>

      <img src="assets/dashboard/sidebar.svg" class="sidebar-hover-icon" alt="Expand sidebar"
        (click)="toggleNavbarCollapse()" />
    </div>

    <!-- Routes - will be centered when collapsed -->
    <div class="routes">
      @for (route of this.noCategories; track route) {
      <app-navbar-item [collapsed]="
            this.currentRoute?.name == 'Pseudocode' || this.navbarCollapsed
          " [route]="route" [active]="this.isRouteActive(route)"></app-navbar-item>
      }
      @for(category of this.nonEmptyCategories; track category.id) {
      <div class="nav-category">
        <div class="nav-category-header" (click)="toggleCategory(category)" role="button"
          [attr.aria-expanded]="category.expanded" tabindex="0" (keydown.enter)="toggleCategory(category)"
          (keydown.space)="toggleCategory(category)">
          <span class="nav-category-title">{{ category.displayName }}</span>
          <span class="nav-category-icon" [class.collapsed]="!category.expanded">▼</span>
        </div>
        <div class="nav-category-items" [class.collapsed]="!category.expanded">
          <div class="nav-category-items-inner">
            @for(route of (this.routesByCategoryCache.get(category.id) || []); track route) {
            <app-navbar-item [collapsed]="this.currentRoute?.name == 'Pseudocode' || this.navbarCollapsed
                  " [route]="route" [active]="this.isRouteActive(route)"></app-navbar-item>
            }
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Class switcher — students only, pinned to bottom of sidebar -->
    @if (!isTeamMember && !isAdminUser) {
    <div class="class-switcher-wrapper">
      <button
        class="class-switcher-btn"
        [disabled]="liveEnrollmentCount === 1 && selectedStudentService.hasSelection"
        (click)="openClassPicker()">
        <mat-icon>school</mat-icon>
        @if (!(this.currentRoute?.name == 'Pseudocode' || navbarCollapsed)) {
        <div class="class-switcher-text">
          <span class="class-switcher-label">
            {{ selectedStudentService.hasSelection ? (selectedStudentService.studentInfo.subject || selectedStudentService.studentInfo.groupName) : 'Select Class' }}
          </span>
          @if (selectedStudentService.hasSelection && selectedStudentService.studentInfo.subject) {
          <span class="class-switcher-sub">
            {{ selectedStudentService.studentInfo.groupName }}
            @if (selectedStudentService.studentInfo.qualificationLevel) {
            <span class="class-switcher-qual">· {{ selectedStudentService.studentInfo.qualificationLevel }}</span>
            }
          </span>
          }
        </div>
        @if (!(liveEnrollmentCount === 1 && selectedStudentService.hasSelection)) {
        <mat-icon class="chevron">swap_horiz</mat-icon>
        }
        }
      </button>
    </div>
    }
  </div>

  <div class="background">
    <!-- <app-ramadan-header class="no-padding"></app-ramadan-header> -->
    <div class="header top-pad" [class.dark-mode]="this.isDark">
      <button class="nav-button" mat-icon-button (click)="this.toggleSideNav()">
        <mat-icon>menu</mat-icon>
      </button>
      @if (this.currentRoute != null) {
      <edu-header-title [darkMode]="this.isDark" [route]="this.currentRoute"></edu-header-title>
      }
      <div class="profile-button-container">
        @if (this.isTeamMember && this.orgImage != '') {
        <img class="org-logo" [src]="this.orgImage" alt="Organization logo" />
        }
        @if (this.environment.org == "ICTeam" && !this.isAdmin) {
        <edu-points-summary [darkMode]="this.isDark" type="points"></edu-points-summary>
        }
        @if (this.environment.org == "CSTeam" && !this.isAdmin) {
        <edu-points-summary [darkMode]="this.isDark" type="trophy" (click)="this.goToTrophies()"></edu-points-summary>
        }
        <profile-button></profile-button>
      </div>
    </div>
    <div class="actual-page" (click)="this.toggleSideNav(false)"
      [class.translator]="this.currentRoute?.name == 'Pseudocode'" [class.dark-mode]="isDark"
      [class.actual-submission]="checkPage()"
      [class.actual-full-height]="isFullHeightPage()">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-onboarding-fab />
<app-help-fab />

<div class="date-time-field" subscriptSizing="dynamic"
  style="position: absolute; top: -10000px; left: -10000px; visibility: hidden">
  <input matInput [matDatepicker]="fauxPicker" />
  <mat-datepicker-toggle matIconSuffix [for]="fauxPicker"></mat-datepicker-toggle>
  <mat-datepicker #fauxPicker></mat-datepicker>
</div>
